/* eslint-disable no-restricted-imports */
import {
  CreateAdminUserDto_Input,
  MutationInput_UserController_CreateOne_Input_RoleName,
} from 'api/generated/graphql';
import { CreateAdminParams } from 'api/types/params';

import { parseRole } from './parseRole';

export const parseCreateAdminParams = (
  params: CreateAdminParams
): CreateAdminUserDto_Input => ({
  ...params,
  roleName: parseRole(
    params.roleName
  )! as MutationInput_UserController_CreateOne_Input_RoleName,
});
